<div id="kiln-details-sidebar-container">
  <h4 class="title">{{ 'KILN_DETAILS.KILN_DETAILS' | translate }}</h4>
  <div class="content">
    <p *ngIf="viewingKilnlinkFreeKilns">{{ 'KILN_DETAILS.KILNLINK_FREE_MESSAGE' | translate }}</p>
    <ion-list *ngIf="details && !viewingKilnlinkFreeKilns">
    <ion-item>
       <ion-label>{{ 'KILN_DETAILS.MODEL_NAME' | translate }}</ion-label>
       <ion-label><p>{{details.model}}</p></ion-label>
     </ion-item>
     <ion-item>
       <ion-label>{{ 'KILN_DETAILS.VOLTAGE' | translate }}</ion-label>
       <ion-label><p>{{details.voltage}}</p></ion-label>
     </ion-item>
     <ion-item>
       <ion-label>{{ 'KILN_DETAILS.PHASE' | translate }}</ion-label>
       <ion-label><p>{{details.phase}}</p></ion-label>
     </ion-item>
     <ion-item>
       <ion-label>{{ 'KILN_DETAILS.SERIAL_NUMBER' | translate }}</ion-label>
       <ion-label><p>{{details.kiln_serial_number}}</p></ion-label>
     </ion-item>
     <ion-item *ngIf="!details.is_kmt">
       <ion-label>{{ 'KILN_DETAILS.KILN_ID' | translate }}</ion-label>
       <ion-label><p>{{details.kiln_id}}</p></ion-label>
     </ion-item>
     <ion-item *ngIf="details.is_kmt">
       <ion-label>{{ 'KILN_DETAILS.CONTROLLER_SERIAL_NUMBER' | translate }}</ion-label>
       <ion-label><p>{{details.serial_number}}</p></ion-label>
     </ion-item>
     <ion-item *ngIf="!details.is_kmt">
       <ion-label>{{ 'KILN_DETAILS.NETWORK_DEVICE_ID' | translate }}</ion-label>
       <ion-label><p>{{details.network_id}}</p></ion-label>
     </ion-item>
     <ion-item *ngIf="details">
       <ion-label>{{ 'KILN_DETAILS.DATE_INSTALLED' | translate }}</ion-label>
        <ion-label *ngIf="details.install_date !== 'N/A'"><p>{{details.install_date | date:'short'}}</p></ion-label>
        <ion-label *ngIf="details.install_date === 'N/A'"><p>{{details.install_date}}</p></ion-label>
     </ion-item>
     <ion-item class="no-pointer">
        <ion-label>{{ 'KILN_DETAILS.FIRMWARE' | translate }}</ion-label>        
        <ion-label *ngIf="showUpdateAvailableIcon" [title]="'KILN_DETAILS.FIRMWARE_UPDATE_AVAILABLE' | translate">
          <ion-icon color="danger" name="warning"></ion-icon>
          {{kilnFirmware}}
        </ion-label>        
        <ion-label *ngIf="!showUpdateAvailableIcon" [title]="'KILN_DETAILS.FIRMWARE_UP_TO_DATE' | translate">
          <ion-icon color="secondary" name="checkmark-circle-outline"></ion-icon>
          {{kilnFirmware}}
        </ion-label>
     </ion-item>
    </ion-list>
    <p *ngIf="!viewingKilnlinkFreeKilns && !details && error && !gettingDetails">{{ 'KILN_DETAILS.ERROR_RETRIEVING_DETAILS' | translate }}</p>
    <p *ngIf="!viewingKilnlinkFreeKilns && gettingDetails && !error">
      <span>{{ 'KILN_DETAILS.RETRIEVING_KILN_DETAILS' | translate }}</span>
      <ion-spinner name="bubbles"></ion-spinner>
    </p>
  </div>
</div>
